import React, { createContext, useState, useCallback } from 'react';
import loadingGraphic from '../resources/images/rings.svg';

export const OverlayContext = createContext({
  setShowLoadingOverlay: null,
  loadingOverlay: null,
});

const OverlayProvider = ({ children }) => {
  const [showLoadingOverlay, setShowLoadingOverlay] = useState(false);

  const loadingOverlay = useCallback(() => {
    return showLoadingOverlay ? (
      <div id="loadingOverlay">
        <div>
          <img width={80} src={loadingGraphic} alt="loading" />
          <p>Loading...</p>
        </div>
      </div>
    ) : null;
  }, [showLoadingOverlay]);

  return (
    <OverlayContext.Provider
      value={{
        loadingOverlay: loadingOverlay,
        setShowLoadingOverlay: setShowLoadingOverlay,
      }}>
      {children}
    </OverlayContext.Provider>
  );
};

export default OverlayProvider;
